export var SmsResendWayType;
(function (SmsResendWayType) {
    SmsResendWayType["NONE"] = "none";
    SmsResendWayType["POLL"] = "poll";
    SmsResendWayType["SPECIFY"] = "specify";
})(SmsResendWayType || (SmsResendWayType = {}));
//# sourceMappingURL=SmsResendWayType.js.map